<template>
  <div>
    <b-card-body>
      <b-card class="importContainer">
        <b-form submit.stop.prevent="save">
          <b-row>
            <b-col sm="12">
              <div>
                <p>Selecione um arquivo para Importar:</p>
                <div class="inputFileGroup">
                  <label for="inputScenario" style=" margin-top: 15px;">
                    <img
                      src="@/assets/abrir.png"
                      style=""
                      :title="$t('openFolderButtomImportScenario')"
                      alt="Abrir pasta local"                      
                    />
                    <span class="txtLimit ml-2">{{fileName}}</span>
                  </label> 
                  <input id="inputScenario" type="file" ref="myFile" accept="application/json" @change="selectedFile">
                </div>
              </div>
              <b-row v-if="importing" class="waitTxt rowDistance">{{$t('importingModelMessage')}}</b-row>
              <br/>             
            </b-col>
          </b-row>
          <b-row class="groupBtn">
            <div>
              <img
                src="@/assets/importar.png"
                style="margin-left: 30px;"
                :title="$t('importScenarioButtom')"
                alt="Importar modelo"
                @click="importJson"
              />
              <img
                src="@/assets/exportar.png"
                style="margin-left: 20px"
                :title="$t('export')"
                alt="Exportar"
                @click="exportJson"
              />
              <img
                src="@/assets/apagar.png"
                style="margin-left: 15px;"
                :title="$t('clear')"
                alt="limpar"
                @click="reset"
              />
            </div>
            <img
              id="closeModalPassword"
              class="float-right"
              src="@/assets/sair.png"
              style="margin-left: 10px;"
              :title="$t('exit')"
              alt="Sair"
              @click="closeImportExport"
            />
          </b-row>
        </b-form>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import axios from "axios";
import { saveAs } from "file-saver";

export default {
  name: "ImportScenario",

  watch: {
    fileName(newTxt){
      this.fileName = this.txtLimits(newTxt)
    }
  },

  data: function() {
    return {
      jsonImport:'',
      dataExport: '',
      fileName: this.$t('noFileSelected'),
      importing: false
    };
  },

  methods:{
    
    async exportJson () {
      const url = `${urlMainAPI}/getJsonForExportMappingLoss`;
      axios
      .get(url)
      .then((res) => {
        this.dataExport = res.data

        let dataToExport = JSON.stringify(this.dataExport, null, "\t");

        let dataExportArq = new Blob([dataToExport], { type: "json;charset=utf-8", });

        saveAs(dataExportArq, "ExportLossScreen" + ".json");
        this.dataExport = "";
        this.$bvModal.hide("configLossScreen");
        defaultSuccess(this.$t('este-arquivo-foi-salvo-em-downloads'));
      })
      .catch();
    },

    async importJson () {
      if (this.jsonImport == '') {
        showError(this.$t('selecione-um-arquivo-json-para-importar'));
        return;
      } else {
        let obj = JSON.parse(this.jsonImport)
        const url = `${urlMainAPI}/saveNewJsonMappingLoss/`

        this.importing = true
        
        await axios
        .post(url, obj)
        .then(res => {
          console.log("response ImportMappingLoss", res)
          defaultSuccess(this.$t('tela-de-perdas-atualizada-com-sucesso'));
          this.importing = false
          this.$bvModal.hide('configLossScreen') 
        })
        .catch(() => {
          this.importing = false
          this.fileName = this.$t('noFileSelected')
          this.$bvModal.hide('configLossScreen') 
        });
      }
    },

    selectedFile() {
      let file = this.$refs.myFile.files[0];
      this.fileName = file.name

      if(!file || file.type !== 'application/json'){
        showError(this.$t('o-arquivo-selecionado-nao-e-do-tipo-json'));
        this.$refs.myFile.value = "";
        this.fileName = this.$t('noFileSelected')
        return;
      }
      let reader = new FileReader();
      
      reader.readAsText(file, "charset=utf-8");
      reader.onload =  evt => {
        this.jsonImport = evt.target.result;
      }
      reader.onerror = evt => {
        console.error(evt);
      } 
    },

    reset() {
      this.$refs.myFile.value = "";
      this.fileName = this.$t('noFileSelected')
      this.xml = "";
    },

    txtLimits(str){
      return str
    },

    closeImportExport() {
        this.areaSelected = "";
        this.$bvModal.hide("configLossScreen");
      },
  }
};
</script>

<style scoped>
.importContainer {
  max-width: 600px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
  margin-top: 5px;
}

.waitTxt {
  justify-content: center;
  background: black;
  color: white;
  margin-bottom: 10px;
}

.rowDistance{
  margin-top: 20px;
}

.inputFileGroup > input {
  display: none;
  text-overflow: ellipsis;
}

.inputFileGroup {
  align-items: baseline;
  max-width: 400px;
}

.txtLimit{
  font-size: 0.8em;
}

.txtLimit:hover {
  cursor: pointer;
}

img {
  cursor: pointer;
  max-height: 35px;
}

@media only screen and (max-width: 770px) {
  .inputFileGroup {
     max-width: 300px;
  }
}
</style>
